import React, { useState } from 'react'
import qs from 'qs'
import { message } from 'antd'
import { useNavigate } from 'react-router-dom'
import {
  EditIdeaMass, InspirationTransfer, LookLgjDetail, RenameSubColl, RemoveSubColl
} from 'component'
import { Icon, DeleteColl, CreateOrEditChildIdeaMass } from 'meinian-package/src/component'
import { request } from 'meinian-package/src/utils'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import Receive, { Receiving } from 'component/receive'
import { IDEA_MASS_ROLE } from 'meinian-package/src/component/enum'
import { Dropdown } from 'meinian-package/src/baseComponent'
import * as userAuth from 'meinian-package/src/utils/auth'
import { useMoveInspiration } from 'component/moveInspiration'
import { renderMoveImage } from 'meinian-package/src/component/useFunModal/moveImage'
import { isPermissions } from 'meinian-package/src//utils/auth'
import { useInspirationContext } from '../inspirationTree.context'
import styles from './index.module.less'

export default ({
  teamInfo,
  onInit,
  auth,
  fetchInfo,
  info,
  setInfo,
  isFreezeFun,
  setChooseDrawerVisible
}) => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const isPro = info.isPro === 1
  const isChild = info.parentId && info.parentId !== -1
  const history = useNavigate()
  const inspirationTree = useInspirationContext()
  const [visible, setVisible] = useState(false)
  const showDetail = () => {
    request.track({ code: 6400005, type: `查看灵感集详情信息-${info.id}` })
  }

  const onSticky = async () => {
    if (info.topStatus) {
      await request.get('/ins/inspiration/remove-top', { params: { inspirationId: info.id } })
      info.topStatus = 0
      setInfo(pre => ({ ...pre }))
    } else {
      await request.get('/ins/inspiration/set-top', { params: { inspirationId: info.id } })
      info.topStatus = 1
      setInfo(pre => ({ ...pre }))
    }
  }

  const authExitCooperation = [IDEA_MASS_ROLE.AUDITOR, IDEA_MASS_ROLE.GATHER, IDEA_MASS_ROLE.VIEWER].includes(info?.loginUserInfo?.role)

  const onExitCooperation = (inspirationId, e) => {
    e.stopPropagation()
    ModalConfirm.show({
      title: '退出协作',
      content: '是否退出协作',
      onOk: async () => {
        request.get('/zhikuan/ins/inspiration/auth/sing-out-inspiration', { params: { inspirationId } }).then(success => {
          if (success) {
            message.success('退出协作成功')
            fetchInfo(isChild)
          }
        })
      }
    })
  }

  return <Dropdown
    trigger="click"
    placement="bottomRight"
    visible={visible}
    overlayClassName=""
    onVisibleChange={_visible => setVisible(_visible)}
    overlay={<div className={styles['more-operation-wrap']}>
      {userAuth.hasInspirationAuth(isChild, auth, ['F02', 'FC03']) ? <LookLgjDetail
        inspirationId={info?.id}
        onChange={() => fetchInfo()}
        isChild={isChild}
      >
        <div
          className="mn-dropdown-icon-li"
          onClick={() => {
            showDetail()
            setVisible(false)
          }}
        >
          <Icon type="m-xiangqing" />{isChild ? '子灵感集详情' : '灵感集详情'}
        </div>
      </LookLgjDetail> : null}
      {userAuth.isPermissions(auth, ['F03', 'FC04', 'FC04_CREATOR']) ? isChild ? <CreateOrEditChildIdeaMass
        isCreate={false}
        auth={auth}
        inspirationId={info.id}
        onChange={() => fetchInfo()}
      >
        <div className="mn-dropdown-icon-li" onClick={() => setVisible(false)}><Icon type="m-bianji" />编辑</div>
      </CreateOrEditChildIdeaMass>
        : <EditIdeaMass
            auth={auth}
            inspirationId={info.id}
            onChange={() => fetchInfo()}
        >
          <div className="mn-dropdown-icon-li" onClick={() => setVisible(false)}>
            <Icon type="m-bianji" />编辑</div>
        </EditIdeaMass> : null}
      {
        isPermissions(auth, ['FS04', 'FS04_CREATOR', 'FCS04', 'FCS04_CREATOR']) && <div
          className="mn-dropdown-icon-li"
          onClick={() => {
            renderMoveImage({
              fromInspirationIdList: [info?.id],
              hasMove: false,
              onChange: () => {
                onInit()
                fetchInfo()
              }
            })
            setVisible(false)
          }}
        ><Icon type="m-yidong" />移动全部款式</div>
      }
      {
        userAuth.isPermissions(auth, ['F16']) && !isChild && isPro && !isFreezeFun(info.freezeStatus) && <>
          <div className="li-partition" />
          <div
            className="mn-dropdown-icon-li"
            onClick={() => {
              setChooseDrawerVisible(true)
              setVisible(false)
            }}
          >
            <Icon type="m-xuankuanrenwu" />
            <div>选款任务</div>
            <div className="mn-dropdown-icon-li-num">{info.missionNum}</div>
          </div>
        </>
      }
      {(isChild && userAuth.isPermissions(auth, ['FC04', 'FC04_CREATOR'])) ? <>
        <div className="li-partition" />
        <RenameSubColl name={info?.name} pInspirationId={info?.parentId} childId={info?.id} onChange={() => fetchInfo()}>
          <div className="mn-dropdown-icon-li" onClick={() => setVisible(false)}><Icon type="m-zhongmingming" />重命名</div></RenameSubColl>
      </>
        : null}
      <div className="li-partition" />
      <div
        className="mn-dropdown-icon-li"
        onClick={() => {
          onSticky()
          setVisible(false)
        }}
      >
        <Icon type="m-zhiding1" />{info.topStatus ? '取消置顶' : '置顶'}
      </div>
      {
      teamInfo?.teamId === 100002143 && <div
        className="mn-dropdown-icon-li"
        onClick={() => {
          setVisible(false); (info.receiveStatus ? Receiving.show({ inspirationId: info.id,
            name: info.name,
            cooperation: info.cooperation,
            onChange: fetchInfo })
            : Receive.show({ inspirationId: info.id, name: info.name, cooperation: info.cooperation, onChange: fetchInfo }))
        }}
      ><Icon type="m-fenxiang" />生成领取链接</div>
    }
      {isChild && userAuth.isPermissions(auth, ['FC06', 'FC06_CREATOR']) ? <div
        className="mn-dropdown-icon-li"
        onClick={() => {
          useMoveInspiration({
            id: info.id,
            onChange: (id, curItem) => {
              if (curItem?.parent) {
                history(`/home/coll/detail/${id}?inspirationId=${id}&parentId=${curItem.parent.value}&name=${curItem.name}`)
                return
              }
              history(`/home/coll/detail/${id}?inspirationId=${id}`)
            }
          })
          setVisible(false)
        }}
      ><Icon type="m-yidong" />移动</div> : null}
      {
        authExitCooperation && <>
          <div className="li-partition" />
          <div className="mn-dropdown-icon-li" onClick={(e) => onExitCooperation(info.id, e)}><Icon type="m-tuichu" />退出协作</div>
        </>
      }
      {isChild && userAuth.isPermissions(auth, ['FC14', 'FC14_CREATOR']) ? <>
        <div className="li-partition" />
        <RemoveSubColl
          name={info?.name}
          pInspirationId={info?.parentId}
          childId={info?.id}
          onChange={() => onInit()}
        >
          <div className="mn-dropdown-icon-li" onClick={() => setVisible(false)}><Icon type="m-qingkongkuanshi" />清空款式</div></RemoveSubColl>
      </> : null}
      {(!isChild && auth.includes('F15')) ? <>
        <div className="li-partition" />
        <InspirationTransfer
          inspirationId={info.id}
          className="inspiration-transfer"
          onChange={fetchInfo}
        >
          <div className="mn-dropdown-icon-li" onClick={() => setVisible(false)}><Icon type="m-zhuanrang" />转让</div>
        </InspirationTransfer>
      </> : null}
      { userAuth.hasInspirationAuth(isChild, auth, ['FC05', 'FC05_CREATOR', 'F04'])
        ? <>
          <div className="li-partition" />
          <div
            className="mn-dropdown-icon-li delete"
            onClick={() => {
              DeleteColl({ params: { inspirationId: info.id },
                onDelete: () => {
                  if (query.parentId) {
                    const parentNode = inspirationTree.findNodeByValue(query.parentId)
                    const curItem = parentNode.current
                    if (curItem?.parent) {
                      history(`/home/coll/detail/${curItem.id}?inspirationId=${curItem.id}&parentId=${curItem.parent.value}&name=${curItem.name}`)
                      return
                    }
                    history(`/home/coll/detail/${curItem.id}?inspirationId=${curItem.id}`)
                  } else {
                    history('/home')
                  }
                } })
              setVisible(false)
            }}
          ><Icon type="m-shanchu" />删除</div>
        </>
        : null}
    </div>}
  >
    <div className={styles['more-operation']}>
      <Icon style={{ fontSize: 20, verticalAlign: 'top' }} type="m-gengduo" />
    </div>
  </Dropdown>
}
